export const EndPointURL = "https://devapi2.kpostindia.com/v2"; // Server

export const LocalPointURL = "https://api.sarojini.co.in/v1";

// http://192.168.2.33:2510/V1